import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconUnapproved = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 23.4,
	height: 23.401,
	viewBox: "0 0 23.4 23.401",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "block_FILL1_wght500_GRAD200_opsz48",
		d: "M5.31,14.85A8.671,8.671,0,0,0,5.9,18.021,11.49,11.49,0,0,0,7.443,20.8L20.8,7.415a9.1,9.1,0,0,0-2.778-1.571A9.482,9.482,0,0,0,14.85,5.31,9.2,9.2,0,0,0,8.088,8.088,9.2,9.2,0,0,0,5.31,14.85ZM8.9,22.286a8.717,8.717,0,0,0,2.764,1.571,9.6,9.6,0,0,0,3.185.533,9.2,9.2,0,0,0,6.762-2.778A9.2,9.2,0,0,0,24.39,14.85a9.263,9.263,0,0,0-.547-3.171A9.681,9.681,0,0,0,22.286,8.9ZM3.15,14.85a11.539,11.539,0,0,1,.912-4.559,11.548,11.548,0,0,1,6.229-6.229,11.854,11.854,0,0,1,9.119,0,11.548,11.548,0,0,1,6.229,6.229,11.855,11.855,0,0,1,0,9.119,11.548,11.548,0,0,1-6.229,6.229,11.855,11.855,0,0,1-9.119,0A11.548,11.548,0,0,1,4.062,19.41,11.539,11.539,0,0,1,3.15,14.85Z",
		transform: "translate(-3.15 -3.15)",
		fill: "#fff"
	})
});
export { SvgIconUnapproved as ReactComponent };
